"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.diseasesMessages = exports.Diseases = void 0;
const schema_1 = require("../../../../../schema");
var Diseases;
(function (Diseases) {
    Diseases["PULMONARY_TUBERCULOSIS"] = "pulmonary_tuberculosis";
    Diseases["CHRONIC_BRONCHITIS"] = "chronic_bronchitis";
    Diseases["BRONCHIAL_ASTHMA"] = "bronchial_asthma";
    Diseases["PNEUMONIA"] = "pneumonia";
    Diseases["PULMONARY_FIBROSIS"] = "pulmonary_fibrosis";
    Diseases["CYSTIC_FIBROSIS"] = "cystic_fibrosis";
    Diseases["OTHER"] = "other";
})(Diseases || (exports.Diseases = Diseases = {}));
exports.diseasesMessages = {
    [Diseases.PULMONARY_TUBERCULOSIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.PULMONARY_TUBERCULOSIS",
        defaultMessage: "Pulmonalis tuberculosis (TBC)"
    },
    [Diseases.CHRONIC_BRONCHITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.CHRONIC_BRONCHITIS",
        defaultMessage: "Krónikus bronchitis"
    },
    [Diseases.BRONCHIAL_ASTHMA]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.BRONCHIAL_ASTHMA",
        defaultMessage: "Asthma bronchiale"
    },
    [Diseases.PNEUMONIA]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.PNEUMONIA",
        defaultMessage: "Pneumonia"
    },
    [Diseases.PULMONARY_FIBROSIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.PULMONARY_FIBROSIS",
        defaultMessage: "Tüdőfibrózis"
    },
    [Diseases.CYSTIC_FIBROSIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.CYSTIC_FIBROSIS",
        defaultMessage: "Cystás fibrosis"
    },
    [Diseases.OTHER]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.respiratoryAndPulmonaryDiseases.diseases.OTHER",
        defaultMessage: "Egyéb"
    }
};
const diseases = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Diseases.PULMONARY_TUBERCULOSIS),
    schema_1.Schema.singleChoiceItem(Diseases.CHRONIC_BRONCHITIS),
    schema_1.Schema.singleChoiceItem(Diseases.BRONCHIAL_ASTHMA),
    schema_1.Schema.singleChoiceItem(Diseases.PNEUMONIA),
    schema_1.Schema.singleChoiceItem(Diseases.PULMONARY_FIBROSIS),
    schema_1.Schema.singleChoiceItem(Diseases.CYSTIC_FIBROSIS),
    schema_1.Schema.singleChoiceItem(Diseases.OTHER)
]).interpretation({ vocab: "ltx", code: "respiratory_pulmonary_disease" });
const comment = schema_1.Schema.string().optional().maxLength(1000).interpretation({
    vocab: "ltx",
    code: "respiratory_pulmonary_disease_comment"
});
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ diseases, comment })
    .interpretation({
    vocab: "ltx",
    code: "respiratory_pulmonary_disease_form"
});
